module.exports = React;


/*****************
 ** WEBPACK FOOTER
 ** external "React"
 ** module id = 24
 ** module chunks = 0 1 2
 **/